<template>
	<div class="pui-form">
		<transportista-modals :modelName="modelName"></transportista-modals>
		<v-form class="pui-transportistaform mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout>
				<v-flex xs8>
					<v-layout wrap class="pui-form-layout">
						<v-flex xs12 v-if="this.method != 'create'">
							<pui-text-field
								:label="$t('transportista.idtransportista')"
								v-model="model.idtransportista"
								required
								disabled
								valueColumnStyles="xs4 sm2 md1"
							></pui-text-field>
						</v-flex>
						<v-flex xs12>
							<pui-text-field
								:label="$t('transportista.nombre')"
								v-model="model.nombre"
								maxlength="100"
								required
								:disabled="formDisabled"
							></pui-text-field>
						</v-flex>
						<v-flex xs12>
							<pui-text-field
								:label="$t('transportista.cif')"
								v-model="model.cif"
								maxlength="30"
								required
								:disabled="formDisabled"
								valueColumnStyles="xs12 sm4 md2 xl2"
							></pui-text-field>
						</v-flex>
						<v-flex xs12>
							<v-layout wrap v-if="this.method != 'create'">
								<v-flex xs6>
									<pui-checkbox
										:label="$t('transportista.indbaja')"
										v-model="model.indbaja"
										:trueValue="'1'"
										:falseValue="'0'"
										disabled
									></pui-checkbox>
								</v-flex>
								<v-flex xs6 v-if="model.indbaja === '1'">
									<pui-date-field
										:label="$t('transportista.fecbaja')"
										v-model="model.fecbaja"
										disabled
										valueColumnStyles="xs6"
									></pui-date-field>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12>
							<pui-text-area
								v-model="model.observaciones"
								:label="this.$t('transportista.observaciones')"
								maxlength="300"
								clearable
								:disabled="formDisabled"
							></pui-text-area>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<pui-form-footer>
				<v-layout>
					<v-flex xs12 sm12 md8 lg8 xl8>
						<v-layout>
							<v-flex xs12 md4>
								<!--<pui-form-mini-audit class="pl-2" :model="model" v-if="this.method !== 'create'"></pui-form-mini-audit>-->
							</v-flex>
							<v-flex xs12 md8>
								<v-layout justify-end fill-height>
									<v-btn v-if="!formDisabled" depressed color="secondary" class="elevation-0" @click.native="save(false)">{{
										this.$t('form.save')
									}}</v-btn>

									<v-btn text outlined @click.native="back()">{{ $t('form.cancel') }}</v-btn>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from 'pui9-mixins/PuiFormMethodsMixin';
import TransportistaActions from './TransportistaActions';
import TransportistaModals from './TransportistaModals';

export default {
	name: 'transportista',
	components: {
		TransportistaModals
	},
	mixins: [PuiFormMethodsMixin],
	data() {
		return {
			modelName: 'transportista',
			actions: TransportistaActions.formactions
		};
	},
	mounted() {
		this.$puiEvents.$on(`refreshForm-action-running-ended-${this.modelName}`, () => {
			//Para hacer recarga de la pantalla del form al realizar una accion
			this.modelLoaded = false;
			this.onReady();
		});
	},
	destroyed() {
		this.$puiEvents.$off(`refreshForm-action-running-ended-${this.modelName}`);
	}
};
</script>

<style scoped></style>

<i18n>
{
    "en": {
        "transportista.idtransportista": "Code",
        "transportista.nombre": "Name",
        "transportista.cif": "Tax identifier",
        "transportista.observaciones": "Comments",
        "transportista.indbaja": "Disabled",
        "transportista.fecbaja": "Disabled date"
    },
    "es": {
        "transportista.idtransportista": "Código",
        "transportista.nombre": "Nombre",
        "transportista.cif": "Identificador fiscal",
        "transportista.observaciones": "Observaciones",
        "transportista.indbaja": "Baja",
        "transportista.fecbaja": "Fecha baja"
    },
    "ca": {
        "transportista.idtransportista": "Codi",
        "transportista.nombre": "Nom",
        "transportista.cif": "Identificador fiscal",
        "transportista.observaciones": "Observacions",
        "transportista.indbaja": "Baixa",
        "transportista.fecbaja": "Data baixa"
    }
}
</i18n>
